import _ from '../../core/utils'

const loadMoreConfig = {
    el: _.select( '.besa__load-more' )
}

export default loadMoreConfig